<template>
  <svg
    :style="`transform: rotate(${rotate}deg); width: ${componentWidth}; height: ${componentHeight}px;`"
    :viewBox="`0 0 ${componentWidth * multiples} ${componentHeight * multiples}`"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g v-for="(list, rowIndex) in imageList" :key="rowIndex">
      <g v-for="(image, columnIndex) in list" :key="columnIndex">
        <circle
          :cx="(getX(rowIndex, columnIndex) + imageSize / 2) * multiples"
          :cy="(getY(rowIndex) + imageSize / 2) * multiples"
          fill="transparent"
          :r="(imageSize / 2) * multiples"
          stroke="#E2E5E0"
        />
        <image
          :clip-path="`circle(${imageSize}px)`"
          :height="imageSize * multiples"
          :transform="`translate(${imageTranslateX(rowIndex, columnIndex) * multiples}, ${imageTranslateY(rowIndex) * multiples}) rotate(${rotate * -1}) translate(-${imageTranslateX(rowIndex, columnIndex) * multiples}, -${imageTranslateY(rowIndex) * multiples})`"
          :width="imageSize * multiples"
          :x="getX(rowIndex, columnIndex) * multiples"
          :xlink:href="image"
          :y="getY(rowIndex) * multiples"
        />
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from 'vue'

interface Props {
  column: number
  columnGap: number
  images: string[]
  imageSize: number
  rotate: number
  row: number
  rowGap: number
}

const props = defineProps<Props>()
const { images, rotate, row, column, rowGap, columnGap, imageSize } = toRefs(props)
const imageList = ref<string[][]>([])
/**
 * 為了讓解析度不要那麼模糊畫布中 * 2
 */
const multiples = 2

onMounted(() => {
  if (images.value.length === 0) {
    return
  }
  const list = randomList(images.value)
  let index = 0
  for (let i = 0; i < row.value; i++) {
    const childList: string[] = []
    for (let j = 0; j < column.value; j++) {
      const image = list[index]
      if (image !== undefined) {
        childList.push(image)
      }
      index++
      if (index >= list.length) {
        index = 0
      }
    }
    imageList.value.push(childList)
  }
})

function randomList<T>([...list]: T[]): T[] {
  const newList: T[] = []
  while (list.length > 0) {
    const [item] = list.splice(Math.floor(Math.random() * list.length), 1)
    if (item !== undefined) {
      newList.push(item)
    }
  }
  return newList
}

/**
 * circle 邊框不要被切到
 */
const circleWidth = 1

const componentWidth = computed(
  () =>
    imageSize.value * (column.value + 0.5) +
    columnGap.value * (column.value - 0.5) +
    circleWidth * 2,
)
const componentHeight = computed(
  () => imageSize.value * row.value + rowGap.value * (row.value - 1) + circleWidth * 2,
)

function getX(rowIndex: number, columnIndex: number): number {
  return (
    (rowIndex % 2 === 1 ? (columnGap.value + imageSize.value) / 2 : 0) +
    (columnGap.value + imageSize.value) * columnIndex +
    circleWidth
  )
}
function getY(rowIndex: number): number {
  return (rowGap.value + imageSize.value) * rowIndex + circleWidth
}
function imageTranslateX(rowIndex: number, columnIndex: number): number {
  return getX(rowIndex, columnIndex) + imageSize.value / 2
}
function imageTranslateY(rowIndex: number): number {
  return getY(rowIndex) + imageSize.value / 2
}
</script>
